import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import FormInputProps from './FormInputProps';

type Props<T extends FieldValues = any> = Omit<
  FormInputProps.CheckboxInput,
  'inputType'
> &
  UseControllerProps<T>;

const CheckboxInput: React.FC<Props> = (props: Props) => {
  const {
    control,
    name,
    rules,
    shouldUnregister,
    defaultValue,
    onChange,
    FormControlLabelProps,
    FormControlProps,
    label,
    helperText,
    ...rest
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
    rules,
    shouldUnregister,
    defaultValue,
  });

  return (
    <FormControl {...FormControlProps} error={!!error}>
      <FormControlLabel
        {...FormControlLabelProps}
        label={label}
        control={
          <Checkbox
            inputRef={field.ref}
            name={field.name}
            checked={field.value || false}
            onChange={
              onChange ? (e) => onChange(e, field.onChange) : field.onChange
            }
            {...rest}
          />
        }
      />
      {(!!error || !!helperText) && (
        <FormHelperText>{error?.message || helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxInput;
